import React, { Component } from "react";
import {
  Button,
  Spinner,
  Toast,
  Card,
  Col,
  Row,
  Form,
  Table,
} from "react-bootstrap-v5";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import SimpleReactValidator from "simple-react-validator";
import Customerinfo from "./CustomerInfo";
import Receiverinfo from "./ReceiverInfo";
import Shipment from "./Shipment";
import Schedule from "./Schedule";
import Carrier from "./Carrier";
import AddOns from "./AddOns";
import Cargo from "./Cargo";
import RevenueAndCost from "./RevenueAndCost";
import Documents from "./Documents";
import Retailer from "./Retailer";
import QuickInfo from "./QuickInfo";
import { paymmentInformation } from "../../../../Function/defaultJobOptions";
import JobService from "../../../../Services/JobService";
import Select from "react-select";
import * as JobOptions from "../../../../Function/defaultJobOptions";
import QuoteBreakedown from "./QuoteBreakedown";
import CourierPartner from "./CourierPartner";

// import { Button, Col, Row, , Form } from "react-bootstrap-v5";

const tabWidth = {
  width: "84%",
};

class ViewJobCart extends Component {
  constructor() {
    super();
    this.validator = new SimpleReactValidator();
    this.state = {
      buttonSubmit: true,
      validationToast: false,
      errorMsgs: [],
      jobData: {},
      removeBookingCount: 0,
      originData: {},
      destinationData: {},
      bookingAmount: 0,
      isInvoice: false,
      isCost: false,
    };
  }
  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);
    const jid = query.get("id");
    JobService.getJobDetails({ job_id: jid }).then((result) => {
      if (result.status === true) {
        let newStateData = result.data;
        let oData, dData;
        this.getPlaceData(newStateData.shipment_details.origin).then((e) => {
          oData = {
            origin_country: e.country,
            origin_country_short_name: e.country_short_name,
            origin_city: e.city,
            origin_latitude: e.latitude,
            origin_longitude: e.longitude,
          };
          this.setState(() => {
            return { originData: oData };
          });
        });
        this.getPlaceData(newStateData.shipment_details.destination).then(
          (e) => {
            dData = {
              origin_country: e.country,
              origin_country_short_name: e.country_short_name,
              origin_city: e.city,
              origin_latitude: e.latitude,
              origin_longitude: e.longitude,
            };

            this.setState(() => {
              return { destinationData: dData };
            });
          }
        );

        if (!newStateData.hasOwnProperty("carrier_details")) {
          newStateData.carrier_details = {
            m_awb_m_b_l: "",
            m_awb_h_b_l: "",
            carrier_name: "",
            port_of_entry: "",
            shipment_type: "",
            comments: "",
          };
        }

        if (!newStateData.hasOwnProperty("payment_information")) {
          newStateData.payment_information = paymmentInformation();
        }

        if (!newStateData.hasOwnProperty("schedule_pickup")) {
          newStateData.schedule_pickup = {
            comments: "",
            pickup: [
              {
                pickup_shipment: "",
                salutation: "",
                sender_name: "",
                pickup_contact: "",
                pickup_date: "",
                pickup_time: "",
                address: "",
                email: "",
                delevered_by: "",
                invoice_no: "",
              },
            ],
          };
        }

        if (!newStateData.hasOwnProperty("document")) {
          newStateData.document = {
            customer_document: [
              {
                document_name: "",
                document_type: "",
                document: "",
                document_file: [],
              },
            ],
            store_document: [
              {
                document_name: "",
                document_type: "",
                document: "",
                document_file: [],
              },
            ],
          };
        }

        if (
          !newStateData.hasOwnProperty("retailer_details") ||
          Object.keys(newStateData.retailer_details).length === 0
        ) {
          newStateData.retailer_details = [];
        }

        this.setState(
          {
            jobData: newStateData,
            removeBookingCount: newStateData.quote_request_items.length,
          },
          () => {
            this.setBookingAmount();
          }
        );
      }
    });
  }

  setBookingAmount = () => {
    const {
      quote_request_airs,
      quote_request_couriers,
      quote_request_lands,
      quote_request_seas,
      shipment_details,
      payment_information,
    } = this.state.jobData;

    if (
      Object.keys(quote_request_airs).length === 0 &&
      Object.keys(quote_request_couriers).length === 0 &&
      Object.keys(quote_request_lands).length === 0 &&
      Object.keys(quote_request_seas).length === 0
    ) {
      this.setState({ bookingAmount: payment_information.booking_amount });
      return false;
    }

    let getFinalQuotezKey;

    let sType = shipment_details.hasOwnProperty("servic_type")
      ? shipment_details.servic_type
      : shipment_details.service_type;

    if (sType.includes("PORT")) getFinalQuotezKey = "port_delivery";
    if (sType.includes("DOOR")) getFinalQuotezKey = "door_delivery";
    if (sType.includes("CONSOLIDATION"))
      getFinalQuotezKey = "consolidation_delivery";

    let bAmt = 0;
    let k = getFinalQuotezKey?.replace("_delivery", "");

    if (sType.includes("AIR")) {
      bAmt =
        quote_request_airs.final[getFinalQuotezKey][
        `discount_${k}_grant_total`
        ];
    } else if (sType.includes("COURIER")) {
      bAmt =
        quote_request_couriers.final.door_delivery.discount_door_grant_total;
    } else if (sType.includes("SEA")) {
      bAmt =
        quote_request_seas.final[getFinalQuotezKey][
        `discount_${k}_grant_total`
        ];
    } else if (sType.includes("LAND")) {
      bAmt =
        quote_request_lands.final[getFinalQuotezKey][
        `discount_${k}_grant_total`
        ];
    }

    this.setState({ bookingAmount: bAmt });
  };

  handleChangeValue = (event, objKey, objInnerKey = "") => {
    let fieldKey = objInnerKey != "" ? objInnerKey : event.target.name;
    let fieldValue =
      event.value == undefined ? event.target.value : event.value;
    let jobCardData = this.state.jobData;

    if (
      fieldKey === "quote_request_items" ||
      fieldKey === "retailer_details" ||
      fieldKey === "is_job_open"
    ) {
      jobCardData[objKey] = fieldValue;
    } else if (fieldKey === "insurance" || fieldKey === "storage") {
      jobCardData[objKey][fieldKey][event.name] = fieldValue;
    } else {
      jobCardData[objKey][fieldKey] = fieldValue;
    }

    this.setState(jobCardData);
  };

  resetAddOnPayment = () => {
    let jobCardData = this.state.jobData;
    jobCardData.payment_information = paymmentInformation();
    jobCardData.add_ons.insurance = {
      insurance_amount: 0,
      insurance_premium: 0,
      items_goods: 0,
      minimum_aed: 0,
    };

    jobCardData.add_ons.storage = {
      handling_in: 0,
      handling_out: 0,
      minimum: 0,
      storage_amount: 0,
      storage_charges: 0,
      storage_value: 0,
    };
    this.setState(jobCardData);
  };

  getPlaceData = (address) => {
    return geocodeByAddress(address).then((results) => {
      const contrypick = results[0].address_components.filter(
        (item) => item.types.indexOf("country") >= 0
      );
      const citypick = results[0].address_components.filter(
        (item) =>
          item.types.indexOf("locality") >= 0 ||
          item.types.indexOf("administrative_area_level_1") >= 0
      );

      return getLatLng(results[0]).then((latlngRes) => {
        let pl = {
          country: contrypick[0].long_name,
          country_short_name: contrypick[0].short_name,
          city: citypick[0].long_name,
          latitude: latlngRes.lat,
          longitude: latlngRes.lng,
        };

        return pl;
      });
    });
  };

  handleChangeOriginDestination = (type, data) => {
    this.setState({ [type]: data });
  };

  formList = (type, item, index, readOnly = false) => {
    const { removeBookingCount, formValidator } = this.props;
    return (
      <Card bg="light" key={`${type}-${index}`}>
        <Card.Body>
          <Card.Title>
            {type.toUpperCase()} - {index + 1}
          </Card.Title>
          <Row>
            <Col>
              <div className="d-flex">
                <div className="position-relative me-2">
                  <label className="form-label">Description</label>
                  <input
                    className="form-control form-control-sm"
                    key={`description-${type}-${index}`}
                    value={item.booking.item_description}
                    name="item_description"
                  />
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Package</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.booking.no_of_pkgs}
                    name="no_of_pkgs"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <div className="d-flex">
                <div className="position-relative me-2">
                  <label className="form-label">Weight</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.booking.kilogram}
                    name="kilogram"
                  />
                </div>
                <div className="position-relative me-2">
                  <label className="form-label">Length</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.booking.length}
                    name="length"
                  />
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Width</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.booking.width}
                    name="width"
                  />
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">Height</label>
                  <input
                    className="form-control form-control-sm"
                    value={item.booking.height}
                    name="height"
                  />
                </div>

                <div className="position-relative me-2">
                  <label className="form-label">
                    <small>Total weight</small>
                  </label>
                  {item.booking.total_weight_KG}
                </div>
                <div className="position-relative me-2">
                  <label className="form-label">
                    <small>Total volume</small>
                  </label>
                  {item.booking.total_volume_CBM}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  render() {
    const { jobData, buttonSubmit, validationToast, errorMsgs } = this.state;

    if (!jobData || Object.keys(jobData).length === 0) return false;

    return (
      <>
        <form className="control-form">
          <QuickInfo
            isview={true}
            // onChangeValue={this.handleChangeValue}
            jobCustData={jobData.customer_details}
            jobShipmentData={jobData.shipment_details}
            jobToken={jobData.job_token}
            isJobOpen={jobData.is_job_open}
            paymentInformation={jobData.payment_information}
            generalDetails={jobData.general_details}
            formValidator={this.validator}
            stateData={{
              jobFinancialStatus: false,
              isDraftedInvoice: true,
              isDraftedCost: true,
            }}
          />
          <div className="d-flex align-items-start">
            <div
              className="nav flex-column nav-pills me-3 bg-white"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <button
                className="nav-link active"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-home"
                type="button"
                role="tab"
                aria-selected="true"
              >
                Customer Info
              </button>

              <button
                className="nav-link"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-profile"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Receiver Info
              </button>

              <button
                className="nav-link"
                id="v-pills-shipment-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-shipment"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Shipment Summary
              </button>

              <button
                className="nav-link"
                id="v-pills-cargo-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-cargo"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Cargo Details
              </button>

              <button
                className="nav-link"
                id="v-pills-addons-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-addons"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Add Ons
              </button>

              <button
                className="nav-link"
                id="v-pills-schedule-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-schedule"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Schedule Pickup
              </button>

              <button
                className="nav-link"
                id="v-pills-carrier-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-carrier"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Carrier Details
              </button>

              <button
                className="nav-link"
                id="v-pills-revenue-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-revenue"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Revenue And Cost
              </button>

              <button
                className="nav-link"
                id="v-pills-document-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-document"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Documents
              </button>

              <button
                className="nav-link"
                id="v-pills-retailer-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-retailer"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Retailer
              </button>
              <button
                className="nav-link"
                id="v-pills-quote-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-quote"
                type="button"
                role="tab"
                aria-selected="false"
              >
                Quote Breakdown
              </button>
              {jobData.added_by.quote_by === "MARKETPLACE" &&
                <button
                  className="nav-link"
                  id="v-pills-quote-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-courier-partner"
                  type="button"
                  role="tab"
                  aria-selected="false"
                >
                  Courier Partners
                </button>
              }
            </div>
            <div
              className="tab-content"
              id="v-pills-tabContent"
              style={tabWidth}
            >
              <div
                className="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <div className="card">
                  <div className="card-header bg-light">
                    <h4>Customer Information</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="mb-3 col-md-6 col-12">
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input
                            className="form-control form-control-sm"
                            name="name"
                            value={jobData.customer_details.name}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Number</label>
                        </div>
                        <PhoneInput
                          className="telinput"
                          country={"ae"}
                          value={jobData.customer_details.mobile_number}
                        />
                      </div>
                      <div className="mb-3 col-md-6 col-12">
                        <div className="mb-3">
                          <label className="form-label">Email</label>
                          <input
                            className="form-control form-control-sm"
                            name="email"
                            value={jobData.customer_details.email}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Type</label>
                          <input
                            className="form-control form-control-sm"
                            name="name"
                            value={jobData.customer_details.user_type}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="">
                          <label className="form-label">Comment</label>
                          <textarea
                            className="form-control form-control-sm"
                            name="comments"
                            value={jobData.customer_details.comments}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              >
                <div className="card">
                  <div className="card-header bg-light">
                    <h4>Receiver Information</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="mb-3 col-md-6 col-12">
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input
                            className="form-control form-control-sm"
                            name="receiver_name"
                            value={jobData.receiver_details.receiver_name}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Number</label>
                          <PhoneInput
                            className="telinput"
                            country={"ae"}
                            value={jobData.receiver_details.pickup_contact}
                          />
                        </div>
                      </div>

                      <div className="mb-3 col-md-6 col-12">
                        <div className="mb-3">
                          <label className="form-label">Email</label>
                          <input
                            className="form-control form-control-sm"
                            name="email"
                            value={jobData.receiver_details.email}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Address</label>
                          <input
                            className="form-control form-control-sm"
                            name="address"
                            value={jobData.receiver_details.address}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="">
                          <label className="form-label">Comment</label>
                          <textarea
                            className="form-control form-control-sm"
                            name="comments"
                            value={jobData.receiver_details.comments}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-shipment"
                role="tabpanel"
                aria-labelledby="v-pills-shipment-tab"
              >
                <div className="card">
                  <div className="card-header bg-light">
                    <h4>Shipment Information</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="mb-3 col-md-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Service</label>
                          <input
                            className="form-control form-control-sm"
                            name="service_type"
                            value={
                              jobData.shipment_details.servic_type.includes(
                                "DOOR"
                              )
                                ? " Door to Door - Direct"
                                : jobData.shipment_details.servic_type.includes(
                                  "CONSOLIDATION"
                                )
                                  ? "Door to Door - Consolidation"
                                  : jobData.shipment_details.servic_type == "NONE"
                                    ? "Select"
                                    : jobData.shipment_details.servic_type.includes(
                                      "PORT"
                                    )
                                      ? "Door to Port"
                                      : ""
                            }
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Shipment Type</label>
                          <input
                            className="form-control form-control-sm"
                            name="shipment_type"
                            value={jobData.shipment_details.shipment_type}
                          />
                        </div>
                      </div>
                      <div className="mb-3 col-md-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Shipping Mode</label>
                          <input
                            className="form-control form-control-sm"
                            name="value_of_goods"
                            value={
                              jobData.shipment_details.shipment_mode.includes(
                                "AIR"
                              )
                                ? "Air Frt"
                                : jobData.shipment_details.shipment_mode.includes(
                                  "SEA"
                                )
                                  ? "Sea Frt"
                                  : jobData.shipment_details.shipment_mode.includes(
                                    "COURIER"
                                  )
                                    ? "Courier"
                                    : jobData.shipment_details.shipment_mode.includes(
                                      "LAND"
                                    )
                                      ? "Land Frt"
                                      : jobData.shipment_details.shipment_mode.includes(
                                        "NONE"
                                      )
                                        ? "Select"
                                        : ""
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Value of Goods</label>
                          <input
                            className="form-control form-control-sm"
                            name="value_of_goods"
                            value={jobData.shipment_details.value_of_goods}
                          />
                        </div>
                      </div>
                      <div className="mb-3 col-md-4 col-12">
                        <div className="mb-3">
                          <label className="form-label">Origin</label>
                          <input
                            className="form-control form-control-sm"
                            name="value_of_goods"
                            value={jobData.shipment_details.origin}
                            readOnly
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Destination</label>
                          <input
                            className="form-control form-control-sm"
                            name="destination"
                            value={jobData.shipment_details.destination}
                          />
                        </div>
                      </div>

                      <div className="col-12 d-flex mt-2">
                        <div className="col-8">
                          <div className="card p-0">
                            <div className="card-header bg-light text-center">
                              <h6 className="mb-0">INSURANCE</h6>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div className="col-4">
                                  <div className="row">
                                    <label className="form-label">OPTED</label>
                                    <div key={`inline-radio`} className="mb-3">
                                      <Form.Check
                                        inline
                                        label="Yes"
                                        name="insurance_opted"
                                        value="yes"
                                        type="radio"
                                        id={`inline-radio-1`}
                                        checked={
                                          jobData.shipment_details
                                            .insurance_opted === "yes"
                                        }
                                      // value={jobData.OPTED}
                                      // onChange={(e) =>
                                      //   this.props.onChangeValue(e, "shipment_details")
                                      // }
                                      />
                                      <Form.Check
                                        inline
                                        label="No"
                                        name="insurance_opted"
                                        value="no"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={
                                          jobData.shipment_details
                                            .insurance_opted === "no"
                                        }
                                      //   value={jobData.OPTED}
                                      // onChange={(e) =>
                                      //   this.props.onChangeValue(e, "shipment_details")
                                      // }
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="row">
                                    <label className="form-label">
                                      APPLIED
                                    </label>
                                    <div key={`inline-radio`} className="mb-3">
                                      <Form.Check
                                        disabled={
                                          jobData.shipment_details
                                            .insurance_opted !== "yes"
                                        }
                                        inline
                                        label="Yes"
                                        name="insurance_applied"
                                        value="yes"
                                        type="radio"
                                        id={`inline-radio-1`}
                                        checked={
                                          jobData.shipment_details
                                            .insurance_applied === "yes" &&
                                          jobData.shipment_details
                                            .insurance_opted === "yes"
                                        }
                                      // onChange={(e) =>
                                      //   this.props.onChangeValue(e, "shipment_details")
                                      // }
                                      />
                                      <Form.Check
                                        disabled={
                                          jobData.shipment_details
                                            .insurance_opted !== "yes"
                                        }
                                        inline
                                        label="No"
                                        name="insurance_applied"
                                        value="no"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={
                                          jobData.shipment_details
                                            .insurance_applied === "no" &&
                                          jobData.shipment_details
                                            .insurance_opted === "yes"
                                        }
                                        onChange={(e) =>
                                          this.props.onChangeValue(
                                            e,
                                            "shipment_details"
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4">
                                  <div className="row">
                                    <label className="form-label">
                                      POLICY RECEIVED
                                    </label>
                                    <div key={`inline-radio`} className="mb-3">
                                      <Form.Check
                                        disabled={
                                          jobData.shipment_details
                                            .insurance_applied !== "yes"
                                        }
                                        inline
                                        label="Yes"
                                        name="insurance_policy_received"
                                        value="yes"
                                        type="radio"
                                        id={`inline-radio-1`}
                                        checked={
                                          jobData.shipment_details
                                            .insurance_policy_received ===
                                          "yes" &&
                                          jobData.shipment_details
                                            .insurance_applied === "yes"
                                        }
                                        onChange={(e) =>
                                          this.props.onChangeValue(
                                            e,
                                            "shipment_details"
                                          )
                                        }
                                      />
                                      <Form.Check
                                        disabled={
                                          jobData.shipment_details
                                            .insurance_applied !== "yes"
                                        }
                                        inline
                                        label="No"
                                        name="insurance_policy_received"
                                        value="no"
                                        type="radio"
                                        id={`inline-radio-2`}
                                        checked={
                                          jobData.insurance_policy_received ===
                                          "no" &&
                                          jobData.insurance_applied === "yes"
                                        }
                                        onChange={(e) =>
                                          this.props.onChangeValue(
                                            e,
                                            "shipment_details"
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {jobData?.schedule_pickup.pickup[0]?.full_name && (
                        <div className="col-12 d-flex mt-2">
                          <div className="col-8">
                            <div className="card p-0">
                              <div className="card-header bg-light text-center">
                                <h6 className="mb-0">
                                  Marketplace Shipment status
                                </h6>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <Table striped bordered hover>
                                    <thead>
                                      <tr>
                                        <th rowSpan="2">Seller Order ID</th>
                                        <th rowSpan="2">Seller Name</th>
                                        <th rowSpan="2">
                                          Shipment Receipt Assorment
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {jobData?.schedule_pickup.pickup &&
                                        jobData?.schedule_pickup.pickup.map(
                                          (item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  {item?.seller_order_id ||
                                                    "-"}
                                                </td>
                                                <td>
                                                  {item?.full_name || "-"}
                                                </td>
                                                <td>
                                                  <Select
                                                    options={JobOptions.shipmentAssorment()}
                                                    name="shpt_receipt_assorment"
                                                    disabled
                                                    readOnly
                                                    value={
                                                      jobData
                                                        ?.schedule_pickup.pickup?.[
                                                        index
                                                      ]
                                                        ?.shpt_receipt_assorment ===
                                                        "NOT_RECEIVED"
                                                        ? {
                                                          value:
                                                            "NOT_RECEIVED",
                                                          label:
                                                            "Not Received",
                                                        }
                                                        : jobData
                                                          ?.schedule_pickup.pickup?.[
                                                          index
                                                        ]
                                                          ?.shpt_receipt_assorment ===
                                                          "PARTIAL_RECEIVED"
                                                          ? {
                                                            value:
                                                              "PARTIAL_RECEIVED",
                                                            label:
                                                              "Partial Received",
                                                          }
                                                          : jobData
                                                            ?.schedule_pickup.pickup?.[
                                                            index
                                                          ]
                                                            ?.shpt_receipt_assorment ===
                                                            "RECEIVED"
                                                            ? {
                                                              value: "RECEIVED",
                                                              label: "Received",
                                                            }
                                                            : null
                                                    }
                                                    onChange={(e) =>
                                                      this.props.handleSelect(
                                                        e,
                                                        "schedule_pickup",
                                                        "shpt_receipt_assorment",
                                                        index
                                                      )
                                                    }
                                                  />

                                                  {
                                                    // formValidator.message('service type', jobData.shipment_type, 'required', { className: 'text-danger' })
                                                  }
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-12">
                        <div className="row">
                          <label className="form-label">Comment</label>
                          <textarea
                            className="form-control form-control-sm"
                            name="comments"
                            value={jobData.shipment_details.comments}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-schedule"
                role="tabpanel"
                aria-labelledby="v-pills-schedule-tab"
              >
                <Schedule
                  isview={true}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.schedule_pickup}
                  jobToken={jobData.job_token}
                  quoteToken={jobData.quote_token}
                  formValidator={this.validator}
                />
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-carrier"
                role="tabpanel"
                aria-labelledby="v-pills-carrier-tab"
              >
                <Carrier
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.carrier_details}
                  formValidator={this.validator}
                />
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-addons"
                role="tabpanel"
                aria-labelledby="v-pills-addons-tab"
              >
                <AddOns
                  isview={true}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.quote_request_items}
                  addOns={jobData.add_ons}
                  jobCargoData={jobData.cargo_details}
                  jobShipmentData={jobData.shipment_details}
                  generalDetails={jobData.general_details}
                  quoteToken={jobData.quote_token}
                  originData={this.state.originData}
                  destinationData={this.state.destinationData}
                  paymentInformation={jobData.payment_information}
                  prevItemCount={this.state.removeBookingCount}
                  itemsBookingAmount={this.state.bookingAmount}
                  formValidator={this.validator}
                />
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-cargo"
                role="tabpanel"
                aria-labelledby="v-pills-cargo-tab"
              >
                <Card>
                  <div className="card-header bg-light">
                    <h4>Cargo Information</h4>
                  </div>
                  <Card.Body>
                    <div className="row">
                      <div className="mb-3 col-md-6 col-12">
                        {jobData.quote_request_items.map((item, index) => {
                          return this.formList("booking", item, index, false);
                        })}
                        <div className="row"></div>
                      </div>
                      <div className="mb-3 col-md-6 col-12">
                        {jobData.quote_request_items.map((item, index) => {
                          return this.formList("actual", item, index);
                        })}
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="mb-3 col-md-3 col-12">
                      <div className="mb-3">
                        <label className="form-label">Value of Goods</label>
                        <input
                          className="form-control form-control-sm"
                          value={jobData.shipment_details.value_of_goods}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-md-6 col-12">
                        <label className="form-label">Comment</label>
                        <textarea
                          className="form-control form-control-sm"
                          value={jobData.cargo_details.comments}
                        />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-revenue"
                role="tabpanel"
                aria-labelledby="v-pills-revenue-tab"
              >
                <RevenueAndCost
                  checkInvoice={(draft) => {
                    this.setState({
                      isInvoice: draft,
                    });
                  }}
                  checkCost={(draft) => {
                    this.setState({
                      isCost: draft,
                    });
                  }}
                  isview={true}
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.retailer_details}
                  jobStatus={jobData.job_status}
                  customerData={jobData.customer_details}
                  receiverData={jobData.receiver_details}
                  bookingData={jobData}
                  quoteToken={jobData.quote_token}
                  carrierData={jobData.carrier_details}
                  payInfoData={jobData.payment_information}
                  jobId={jobData._id}
                  formValidator={this.validator}
                />
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-document"
                role="tabpanel"
                aria-labelledby="v-pills-document-tab"
              >
                <Documents
                  onChangeValue={this.handleChangeValue}
                  jobData={jobData.document}
                  formValidator={this.validator}
                />
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-retailer"
                role="tabpanel"
                aria-labelledby="v-pills-retailer-tab"
              >
                <Retailer
                  isview={true}
                  onChangeValue={this.handleChangeValue}
                  // jobData={jobData.retailer_details}
                  jobId={jobData._id}
                  formValidator={this.validator}
                />
              </div>
              <div
                className="tab-pane fade"
                id="v-pills-quote"
                role="tabpanel"
                aria-labelledby="v-pills-quote-tab"
              >
                <QuoteBreakedown
                  //   isview={this.state.isview}
                  // onChangeValue={this.handleChangeValue}
                  jobData={jobData}
                  shipmentDetails={jobData.shipment_details}
                // formValidator={this.validator}
                />
              </div>
              {jobData.added_by.quote_by === "MARKETPLACE" &&
                <div
                  className="tab-pane fade"
                  id="v-pills-courier-partner"
                  role="tabpanel"
                  aria-labelledby="v-pills-quote-tab"
                >
                  <CourierPartner
                    jobData={jobData}
                    itemList={jobData.quote_request_items}
                    pickupList={jobData.schedule_pickup.pickup}
                    job_token={jobData.job_token}
                    receiver_details={jobData.receiver_details}
                    disabled={true}
                  />
                </div>
              }
            </div>
          </div>
        </form>
      </>
    );
  }
}
export { ViewJobCart };
